import React, { useState } from 'react'

import { copy } from '@local/do-secundo-clipboard-utilities'
import { TagDisplayIcon } from '@toasttab/buffet-pui-icons'
import { useRestaurantStorage } from '../../../../client/utils/restaurant-storage'
import { useVariant } from '../../../../client/hooks/use-variant'
import { XP_APPLY_PROMO } from '../../../../client/components/ExperimentsProvider/experiment-definitions'

import { Banner } from '../Banner'
import { PromoCodeBanner as PromoCodeBannerType } from '../@types'

type PromoCodeBannerProps = {
  banner: PromoCodeBannerType
  testId: string
}

export const PromoCodeBanner = ({ banner, testId }: PromoCodeBannerProps) => {
  const applyPromoVariant = useVariant(XP_APPLY_PROMO.experimentName)

  const [isCopied, setIsCopied] = useState(false)
  const { bannerGuid, bannerText, promoCode } = banner

  // copies the promo code to clipboard
  const handleCopyClick = async (promoCodeText: string) => {
    try {
      await copy(promoCodeText)
      setIsCopied(true)
    } finally {
      setTimeout(() => setIsCopied(false), 1500)
    }
  }

  const { get: getFromSession, set: setToSession } =
    useRestaurantStorage(sessionStorage)

  let codeGuidInSession: string | undefined
  try {
    codeGuidInSession = getFromSession('appliedPromoCode')?.guid
  } catch {}
  const [appliedCodeGuid, setAppliedCodeGuid] = useState(codeGuidInSession)

  const handleApplyClick = (bannerGuid: string, promoCodeText: string) => {
    setToSession('appliedPromoCode', { guid: bannerGuid, text: promoCodeText })
    setAppliedCodeGuid(bannerGuid)
  }

  return (
    <Banner testId={testId}>
      <Banner.BannerIcon>
        <TagDisplayIcon size='md' testId='promo-code-banner-icon' />
      </Banner.BannerIcon>
      <Banner.BannerText>
        <Banner.BannerTitle>{bannerText}</Banner.BannerTitle>
        <Banner.BannerDescription>
          <span>{promoCode}</span>
          {applyPromoVariant === 1 ? (
            <button
              className='text-color-link text-base font-semibold border-none active:bg-transparent focus:bg-transparent bg-transparent cursor-pointer ml-4 p-0 w-24'
              data-testid='promo-code-banner-apply-button'
              id='promoBannerApplyButton'
              onClick={() => handleApplyClick(bannerGuid, promoCode)}
            >
              {appliedCodeGuid === bannerGuid ? 'Applied!' : 'Apply code'}
            </button>
          ) : (
            <button
              className='text-color-link text-base font-semibold border-none active:bg-transparent focus:bg-transparent bg-transparent cursor-pointer ml-4 p-0 w-24'
              data-testid='promo-code-banner-copy-button'
              id='promoBannerCopyButton'
              onClick={() => handleCopyClick(promoCode)}
            >
              {isCopied ? 'Copied!' : 'Copy code'}
            </button>
          )}
        </Banner.BannerDescription>
      </Banner.BannerText>
    </Banner>
  )
}
